module.exports = __webpack_public_path__ + "static/chirpyest-text-logo-8fc7ea04d6e6dacecbc740b68653a8de.png";